import { SET_SUBSCRIPTIONS } from './actionTypes';

const setLocalSubscriptions = (subscriptions) => (dispatch) => {
	dispatch({ type: SET_SUBSCRIPTIONS, payload: subscriptions });
};

export { setLocalSubscriptions };
